import { Component, OnInit } from '@angular/core';
import { environment } from '../../shared/config/app-config';
import { ActivatedRoute, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { UserService, User } from '../../shared';
import { SafeResourceUrl } from '@angular/platform-browser';


@Component({
  templateUrl: 'postoperative.component.html',
  styleUrls: ['./style.component.css']


})

export class PostoperativeComponent implements OnInit {
  public data: Object;
  CurrentUser: User
  documenturl: string = environment.documenturl;
  apiurl: any = environment.api_url;
  type: any
  path: any;
  urlSafe: SafeResourceUrl;
  
  constructor(

    private router: Router,
    private route: ActivatedRoute,
    private userService: UserService


  ) {

  }




  ngOnInit() {
    this.route.params.subscribe(params => this.type = params);
    this.userService.currentUser.subscribe(
      (userData) => {
        this.CurrentUser = userData;
      }
    )
    if (this.route.snapshot.url[0].path != 'assessment') {
      this.CurrentUser.operationStatus = ''
    }
    this.path = this.documenturl + sessionStorage.getItem("bulletinboardFilePath");
    if(!this.path) {
      this.userService
        .getbulletinboard(this.type.type)
        .subscribe(
          data => {
            for (var i = 0; i < data.length; i++) {

              if (data[i].bulletinBoardId == this.type.id) {
                this.path = this.documenturl + data[i].filePath;
                this.getURLContent();
              }
            }
          }
        );
      } else this.getURLContent();
  }

  getURLContent() {
    this.userService.getHTMLContent(this.path).subscribe((dataContent) => {
      this.urlSafe = dataContent;
    })
  }
  ngOnDestroy() {
    sessionStorage.removeItem("bulletinboardFilePath");
  }
  onNavigate() {
    let printContents;
    window.open(this.path, '_blank', 'top=0,left=0,height=100%,width=auto');
  }

}






